<template>
  <div class="common-drag-panel">
    <div class="content" ref="content"><slot></slot></div>
    <!-- <div class="drag-line" @mousedown="handleMOuseDown"></div> -->
  </div>
</template>

<script>
export default {
  methods: {
    handleMOuseDown(e) {
      this.mouseDownX = e.clientX;
      this.contentBoxWidth = this.$refs.content.clientWidth;
      document.addEventListener("mousemove", this.handleMouseMove);
      document.addEventListener("mouseup", this.handleMouseUp);
    },
    handleMouseMove(e) {
      let deltaX = e.clientX - this.mouseDownX;
      if (this.contentBoxWidth + deltaX > 400) {
        this.$refs.content.style.width = `400px`;
      } else if (this.contentBoxWidth + deltaX < 200) {
        this.$refs.content.style.width = `200px`;
      } else {
        this.$refs.content.style.width = `${this.contentBoxWidth + deltaX}px`;
      }
    },
    handleMouseUp() {
      document.removeEventListener("mousemove", this.handleMouseMove);
    },
  },
};
</script>

<style lang="less" scoped>
.common-drag-panel {
  display: flex;

  .content {
    width: 100%;
  }

  .drag-line {
    width: 2px;
    cursor: e-resize;
  }
}
</style>